<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent">
      <div class="wrap">
        <div class="content">
          <h5 class="page-title">
            <span class="blue title-line"></span> 银行卡认证
          </h5>
          <div class="main-box">
            <p class="warning">
              <i class="el-icon-warning"></i>
              &nbsp;&nbsp;&nbsp;&nbsp;请务必提供真实信息，公司有权自行或委托第三方，审查提供的身份信息是否真实、有效。若提供虚假信息，由此带来的后果由提供方承担。
            </p>
            <div class="form">
              <div class="form"></div>
              <el-form
                :model="applyForm"
                :rules="applyrules"
                ref="applyForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="真实姓名:" label-width="130px" prop="name">
                  <el-input
                    :disabled="[0,1,2].includes(status)"
                    v-model="applyForm.name"
                    placeholder="请输入您的真实姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="证件号码:"
                  label-width="130px"
                  prop="idCard"
                >
                  <el-input
                    :disabled="[0,1,2].includes(status)"
                    v-model="applyForm.idCard"
                    placeholder="请输入您的身份证号"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="银行卡号:"
                  label-width="130px"
                  prop="bankNo"
                >
                  <el-input
                    v-model="applyForm.bankNo"
                    placeholder="请输入您的银行卡号"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="手机号码:"
                  label-width="130px"
                  prop="phone"
                >
                  <el-input
                    v-model="applyForm.phone"
                    placeholder="请输入该卡在银行预留的手机号码"
                  ></el-input>
                </el-form-item>
                <div class="yzm-item">
                  <el-form-item label="验证码:" label-width="130px" prop="code">
                    <el-input
                      v-model="applyForm.code"
                      placeholder="短信验证码"
                    ></el-input>
                  </el-form-item>
                  <span :disabled="disabled" @click="getVerificationCode">{{
                    yzmtext
                  }}</span>
                </div>
                <el-form-item class="btns"  label-width="0">
                  <span @click="submit('applyForm')">提交认证</span>
                  <b @click="cancel">取消</b>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="captcha-element"></div>
  </el-row>
</template>

<script>
import { Loading } from "element-ui";
import { identification } from "@http/user_center/userInfo";
import NoTrace from '@/utils/noTrace';
import {sendMsg} from '@http/user_center/realName'

import qs from "qs";
var interval = null;
export default {
  data() {
    var vphone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      }
      callback();
    };
    var bankno = (rule, value, callback) => {
      if (!/^\+?[0-9][0-9]*$/.test(value)) {
        callback(new Error("请输入正确的银行卡号"));
      }
      callback();
    };
    return {
      active: 0,
      applyForm: {
        name: "",
        idCard: "",
        bankNo: "",
        phone: "",
        code: "",
      },
      applyrules: {
        name: [
          { required: true, message: "请输入您的真实姓名", trigger: "blur" },
        ],
        idCard: [
          { required: true, message: "请输入您的身份证号", trigger: "blur" },
        ],
        bankNo: [
          { required: true, message: "请输入您的银行卡号", trigger: "blur" },
          { validator: bankno, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: vphone, trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      yzmtext: "获取验证码",
      disabled: false,
      currentTime: 60,
      isSign:false,
      status:'',
    };
  },

  components: {},

  computed: {
    channelCodeValue(){
        return this.$store.state.config.channelCodeValue;
    },
  },

  created() {
    identification({hidden:false}).then((res) => {
        this.applyForm.name=res.personal?.name;
        this.applyForm.idCard=res.personal?.idCard;
        this.status=res.authenticationStatus;
    }).catch((err) => {
        console.log(err);
    });
    if(this.$getlocalStorage('queryData')?.identifyType==1 || this.$route.query?.identifyType==1){
        this.isSign=true;
    }
  },

  mounted() {
    zhuge.track('用户中心_银行卡开始认证', {'渠道': this.channelCodeValue})
    NoTrace.init('captcha-element', 'captcha-button')
  },
  beforeDestroy() {
      NoTrace.reset()
  },

  methods: {
    getVerificationCode() {
      var that = this;
      if (!/^1[3456789]\d{9}$/.test(this.applyForm.phone)) {
        this.$msg("请输入正确的手机号");
        return false;
      }
      this.$TsaWebTrace.post({
          data: {
              "eventId": 35022,
              "logParam":{
                  'phone':this.applyForm.phone,
              }
          },
      });
      this.getCode();
      that.disabled = true;

      // 开始获取无痕验证码
      NoTrace.start((nvc) => {
          this.nvc = nvc
      }, this.executeFun, {
          phone: that.applyForm.phone,
          nvc: '',
          afsVersion: 2
      })
    },
    executeFun (params) {
        let that=this;
        return new Promise(async (resolve, reject) => {
            try {
                let res = await sendMsg(params);
                resolve(res)
                that.$msg("验证码已发送，请注意接收", "success");
            }catch (err) {
                reject(err)
                that.$msg('发送失败')
                clearInterval(interval);
                that.currentTime = 60;
                that.yzmtext = "重新获取";
                that.disabled = false;
            }
        })
    },
    getCode() {
      var that = this;
      var currentTime = that.currentTime;
      interval = setInterval(function () {
        currentTime--;
        that.yzmtext = "(" + currentTime + "s)重新获取";
        if (currentTime <= 0) {
          clearInterval(interval);
          that.yzmtext = "重新获取";
          that.currentTime = 60;
          that.disabled = false;
        }
      }, 1000);
    },
    submit(formName) {
        zhuge.track('用户中心_个人提交认证', {'渠道': this.channelCodeValue})
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this;
          let loadingInstance = Loading.service();
          let clientId=this.$getlocalStorage("queryData")?this.$getlocalStorage("queryData").clientId:'';
          if(clientId){
            this.applyForm = Object.assign({},this.applyForm,{clientId})
          }
          if(this.isSign){
              this.applyForm.identifyType=1;
          }
          this.$TsaWebTrace.post({
              data: {
                  "eventId": 35010,
              },
          });
          this.$request({
            method: "post",
            url: "/identification/personal/apply",
            data: qs.stringify(this.applyForm),
          })
            .then((res) => {
              that.$nextTick(() => {
                loadingInstance.close();
              });
              that.$msg("已认证为自然人用户", "success");
              that.$store.dispatch('userInfo/setLawyerInfo', {})
              zhuge.track('用户中心_个人认证成功', {'渠道': this.channelCodeValue,'用户行为':'实名认证'})
              let redirectUrl = that.$getlocalStorage("queryData")?that.$getlocalStorage("queryData").redirectUrl:'';
              setTimeout(() => {
                if (redirectUrl) {
                  localStorage.removeItem("queryData");
                  window.location.href =decodeURI(redirectUrl)
                  // if (redirectUrl.indexOf("?") === -1) {
                  //   window.location.href =
                  //     decodeURI(redirectUrl) +
                  //     "?access_token=" +
                  //     res.data.access_token;
                  // } else {
                  //   window.location.href =
                  //     decodeURI(redirectUrl) +
                  //     "&access_token=" +
                  //     res.data.access_token;
                  // }
                } else {
                    if(this.$getlocalStorage("queryData")?.from=='lawcase'){
                        zhuge.track('律师咨询_实名认证成功',{'端':'PC'},()=>{
                          this.$store.dispatch('userInfo/setLawyerInfo', {})
                            if(this.$getlocalStorage("queryData")?.to){
                              window.location.href =`${process.env.VUE_APP_LAWCASE}/userCenter/authentication?to=${this.$getlocalStorage("queryData").to}&randomKey=${this.$getlocalStorage("queryData").randomKey || ''}`
                            }else{
                                window.location.href =`${process.env.VUE_APP_LAWCASE}/userCenter/authentication`
                            }                           
                        })
                    }else{
                        that.$router.replace({
                            path: "/userCenter/AuthenticationName",
                        });
                    }
                }
              }, 3000);
              console.log(res);
            })
            .catch((err) => {
              that.$nextTick(() => {
                loadingInstance.close();
              });
              console.log(err);
              that.$msg(err.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel() {
      if(this.status==-1){
        this.$router.replace({
            path: "/userCenter/AuthenticationName/Individual",
        });
      }else{
        this.$router.replace({
            path: "/userCenter/AuthenticationName",
        });
      }
      
    },
  },
};
</script>
<style src="../../assets/css/content.css" scoped></style>
<style scoped>
.main-box {
  text-align: center;
}
.form {
     width: 40%;
    margin: 30px auto;
}
.kuang {
  box-sizing: border-box;
  margin-bottom: 20px;
  padding: 32px;
  width: 100%;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 4px 6px 0px rgba(172, 172, 172, 0.18);
}
.kuang .page-title {
  margin-bottom: 30px;
}
.form .el-form-item {
}
.yzm-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.yzm-item .el-form-item {
}
.yzm-item span {
  width: 130px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background: #fff;
  color: #3f7df7;
  cursor: pointer;
  border: 1px solid #3f7df7;
  font-size: 14px;
  margin-left: 10px;
  box-sizing: border-box;
  margin-top:3px;
}
.yzm-item span:hover {
  background: #3f7df7;
  color: #fff;
}
.yzm-item span[disabled] {
  color: #fff;
  background: #bcbcbc;
  pointer-events: none;
  cursor: inherit;
  border-color: #bcbcbc;
}
.btns {
  margin-top: 50px;
}
.btns span {
  display: inline-block;
  text-align: center;
  width: 148px;
  height: 40px;
  line-height: 40px;
  color: #3080fe;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #3080fe;
}
.btns b {
  margin-left: 30px;
  display: inline-block;
  text-align: center;
  width: 148px;
  height: 40px;
  line-height: 40px;
  color: #999;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #ccc;
}
.btns b:hover {
  color: #333;
  background: #f5f5f5;
}
.btns span:hover {
  background: #3080fe;
  color: #fff;
}
</style>
<style>
/* .form .el-form-item__label {
  text-align: left;
} */
</style>
